var map = {
	"./Presentation/Chats/ViewModel": 8476,
	"./Presentation/Chats/ViewModel.js": 8476,
	"./Presentation/Chats/ViewStyles": 78686,
	"./Presentation/Chats/ViewStyles.js": 78686,
	"./Presentation/Chats/ViewUI": 78987,
	"./Presentation/Chats/ViewUI.js": 78987,
	"./Presentation/Chats/__tests__/ViewUI.spec": 8179,
	"./Presentation/Chats/__tests__/ViewUI.spec.js": 8179,
	"./Presentation/components/Alert": 94650,
	"./Presentation/components/Alert/": 94650,
	"./Presentation/components/Alert/Alert.spec": 38042,
	"./Presentation/components/Alert/Alert.spec.js": 38042,
	"./Presentation/components/Alert/Alert.styles": 58441,
	"./Presentation/components/Alert/Alert.styles.js": 58441,
	"./Presentation/components/Alert/index": 94650,
	"./Presentation/components/Alert/index.js": 94650,
	"./Presentation/components/Button": 39686,
	"./Presentation/components/Button/": 39686,
	"./Presentation/components/Button/Button.styles": 61108,
	"./Presentation/components/Button/Button.styles.js": 61108,
	"./Presentation/components/Button/helpers/getButtonPadding": 55640,
	"./Presentation/components/Button/helpers/getButtonPadding.js": 55640,
	"./Presentation/components/Button/helpers/getDataAttributeValue": 62615,
	"./Presentation/components/Button/helpers/getDataAttributeValue.js": 62615,
	"./Presentation/components/Button/index": 39686,
	"./Presentation/components/Button/index.js": 39686,
	"./Presentation/pages/Channel/components/Footer": 85100,
	"./Presentation/pages/Channel/components/Footer/": 85100,
	"./Presentation/pages/Channel/components/Footer/Footer.spec": 51587,
	"./Presentation/pages/Channel/components/Footer/Footer.spec.js": 51587,
	"./Presentation/pages/Channel/components/Footer/Footer.styles": 32901,
	"./Presentation/pages/Channel/components/Footer/Footer.styles.js": 32901,
	"./Presentation/pages/Channel/components/Footer/index": 85100,
	"./Presentation/pages/Channel/components/Footer/index.js": 85100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 578;